<template>
  <modal name="contact-user" width="40%" height="auto" :scrollable="true">
    <button
      @click="hide('contact-user')"
      style="margin:5% 5%; cursor:pointer"
      class="pull-right"
    >
      <span class="mdi mdi-alpha-x-circle"></span>
    </button>
    <div style="margin-top:5%;" class="form-group col-8">
      <h4 style="color:black">
        {{ $t("action.contact") }} {{ user.username }}
      </h4>
    </div>
    <form @submit="send" class="form form-message">
      <div class="col-12" v-if="message != ''">
        <div class="alert alert-info">{{ message }}</div>
      </div>
      <div class="form-group col-12" style="margin-bottom: 2%;">
        <textarea
          style=" height: 120px"
          class="form-control"
          :placeholder="'Ecrivez un message à ' + user.username"
          v-model="text"
        ></textarea>
      </div>
      <div class="form-group col-12 pull-right">
        <button type="submit" style="margin-right: 3%;" class="btn btn-site">
          {{ $t("action.send") }}
        </button>
        <button
          type="btn"
          style="padding: 13px 25px 11px !important;"
          @click="hide('contact-user')"
          class="btn btn-danger"
        >
          {{ $t("action.cancel") }}
        </button>
      </div>
    </form>
  </modal>
</template>

<script>
export default {
  props: {
    user: {
      type: Object,
    },
  },
  data() {
    return {
      text: "",
      message: "",
    };
  },
  methods: {
    hide(modalName) {
      event.preventDefault();
      this.$modal.hide(modalName);
    },
    send() {
      var self = this;
      event.preventDefault();
      if (self.text == "") {
        self.message = "Veuillez ecrire un message";
        return;
      }

      this.$axios({
        url: "conversation/send",
        method: "POST",
        data: { to: self.user.id, text: self.text },
      })
        .then(() => {
          this.$modal.hide("contact-user");
          self.$notify({
            group: "success",
            title: "Bravo !",
            type: "success",
            text: "Utilisateur contacté avec succès !",
          });
        })
        .catch((err) => {
          if (err.response.status === 403) {
            self.message = self.$t("api.permissions");
          } else {
            self.message = self.$t(err.response.data.message);
          }
        });
    },
  },
};
</script>
